import CountButton from "./CountButton";
import SearchFilter from "./SearchFilter";

import css from './SearchBar.module.css';


function SearchBar ({filter, setFilter, sortedAndFilteredData}) {
  return (
            <div className={css.control}>
                <SearchFilter filter={filter} setFilter={setFilter} />
                <CountButton sortedAndFilteredData={sortedAndFilteredData}/>
            </div>

  )
}  
export default SearchBar;